import React, { useRef } from "react";
import Header from "./Header";
import emailjs from "@emailjs/browser";
import Footer from "./Footer";

const Contact = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_bn2t6mq', 'template_u6qd77c', form.current, {
        publicKey: 'OkaiWlzfwbzzc1yBo' })
          .then(() => {
            console.log('SUCCESS!');
            e.target.reset();
            alert("Email Sent !");
        }, (error) => {
            console.log('FAILED...', error.text);
            },
          );
      };


    return (
        <>
        <Header></Header>
         <section className="contact" id="contact">
        <h2 className="heading">CONTACT ME</h2>
        <form ref={form} onSubmit={sendEmail}>
            <div className="input-group">
                <div className="input-box">
                    <input type="text" placeholder="Your Name" name="your_name" />
                    <input type="email" placeholder="Your Email" name="your_email" />
                    <textarea rows="10" placeholder="Your Message" name="message"></textarea>
                    <button type="submit" value="Send" className="btn" >Submit</button>
                </div>
            </div>  
        </form>
    </section>
    <Footer></Footer>
        </>
    )
}
export default Contact;